
import React, { PureComponent } from 'react';
import "./Forms.css";
// add .error to component for error state.

class Select extends PureComponent {
  static defaultProps = {
    Options: [],
    Disabled: false,
    Inverse: false,
    ariaLabel:'',
    autoComplete:'off'
  };
  constructor(props) {
    super(props);

  }

  render() {
    const { Options, Selected, Disabled, Name, Inverse } = this.props;
    const entries = Object.entries(Options)
    function sortable(entries, Inverse) {
      if (Inverse == true) {
        return entries.sort((a, b) => {
          var x = a[1].toLowerCase();
          var y = b[1].toLowerCase();
          return x > y ? -1 : x < y ? 1 : 0;
        })
      } else {
        return entries.sort((a, b) => {
          var x = a[1].toLowerCase();
          var y = b[1].toLowerCase();
          return x < y ? -1 : x > y ? 1 : 0;
        })
      }
    }
    
    const sortableOptions = sortable(entries, Inverse)
    return (
      <div className="form-wrapper">
        <select
          disabled={Disabled ? true : false}
          value={Selected}
          onChange={this.props.onChange}
          name={Name}
          aria-label={this.props.ariaLabel}
          autoComplete={this.props.autoComplete}
          className={this.props.customClassName}
          >
          {
            sortableOptions.map(function (option, key) {
              return <option
                value={option[0]}
                key={key}
                disabled={option[0].length < 1}
                selected={option[0].length < 1}
              >
                {option[1]}
              </option>

            })}
        </select>
      </div>
    );
  }
}
export default Select;
